import { render } from "./NumberFormat.vue?vue&type=template&id=3efb7d29"
import script from "./NumberFormat.vue?vue&type=script&lang=js"
export * from "./NumberFormat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__